import { NODE_ENV } from "../../constants/env";
import { isAuthError } from "../auth-error/is-auth-error";
import { attemptChunkLoadRecovery } from "../chunk-load-recovery/attempt-chunk-load-recovery";

export function handleErrorBoundaryError(error: Error): void {
  if (NODE_ENV === "development") {
    console.error(error);
    return;
  }

  if (attemptChunkLoadRecovery(error)) {
    return;
  }

  if (isAuthError(error)) {
    return;
  }

  window.location.href = "/unexpected-error.html";
}
